import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { resolveActivatedRouteParam } from 'src/app/utils/resolve-activated-route-params';

@Injectable()
export class SectorIdResolver {
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): string {
    return resolveActivatedRouteParam(route, 'sector_id');
  }
}
